var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 6h-.004a.895.895 0 0 0-.265-.555L16.555 1.27A.894.894 0 0 0 16 1.004V1H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6ZM5 4a1 1 0 0 1 1-1h9v3.09c0 .502.408.91.91.91H19v13c0 .028-.001.055-.003.082l-8.79-8.79a1 1 0 0 0-1.444.032L5 15.43V4Zm0 14.389V20a1 1 0 0 0 1 1h11.086L9.53 13.446 5 18.389Z",
  fill: "currentColor"
})));
export default SvgFileImage;